<template>
  <v-dialog
    v-model="internalDialogVisible"
    width="600px">
    <v-card>
      <v-card-title>
        You are about to leave HawkSoft Marketplace
      </v-card-title>
      <v-card-text>
        <div class="text--primary text-justify">
          HawkSoft offers links to partner and third-party websites that may be of interest to our customers. When you click on these links you leave the HawkSoft website and are redirected to a third-party site.
          If you have any questions or concerns about the products and services offered on linked third-party websites, please contact the third-party directly.
          HawkSoft Customer Service can assist on identifying the correct person to speak with.
        </div>
      </v-card-text>
      <v-card-actions>
        <v-col>
          <v-btn @click="close()">Return to Marketplace</v-btn>
        </v-col>
        <v-col align-end>
          <v-btn :href="url" color="primary">Continue</v-btn>
        </v-col>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LeavingDialog',
  props: {
    showLeavingDialog: Boolean,
    url: {
      type: String,
      required: true
    }
  },
  computed: {
    internalDialogVisible: {
      get: function () {
        return this.showLeavingDialog;
      },
      set: function (visible) {
        if (!visible) {
          this.$emit('close');
        }
      }
    }
  },
  methods: {
    close: function () {
      this.internalDialogVisible = false;
    }
  }
};

</script>
